import { useState } from 'react'

import { FormattedMessage } from 'react-intl'

import CloseIcon from 'app/assets/icons/close-icon.svg'
import SkinnyBannerImage from 'app/assets/images/skinny-banner-image.png'
import Box from 'app/components/base/Box'
import IconButton from 'app/components/base/IconButton'
import Image from 'app/components/base/Image'
import Stack from 'app/components/base/Stack'
import Text from 'app/components/base/Text'
import { getStaticImageSrc } from 'app/utils/helpers/functions.helpers'

import HomeViewContainer from './HomeViewContainer'

export const SkinnyBanner = () => {
  const [isHideBanner, setHideBanner] = useState<boolean>(false)

  if (isHideBanner) return null

  return (
    <Box
      sx={{
        background: 'linear-gradient(90deg, #17D3FF 0%, #00EA90 100%)',
        height: 40,
        display: { xs: 'none', md: isHideBanner ? 'none' : 'block' }
      }}
    >
      <HomeViewContainer>
        <Stack
          direction="row"
          spacing={2}
          sx={{
            justifyContent: 'space-between',
            position: 'relative',
            alignItems: 'center'
          }}
        >
          <Text
            variant="h5"
            sx={{ fontWeight: 500, color: 'primary.main', py: 1.25 }}
          >
            <FormattedMessage defaultMessage="The Car Parts Marketplace - Find, Buy & Sell Parts in Seconds" />
          </Text>

          <Stack direction="row" spacing={2} sx={{ alignItems: 'center' }}>
            <Box sx={{ position: 'relative', width: 200, height: 40 }}>
              <Image
                src={getStaticImageSrc(SkinnyBannerImage)}
                alt="homepage banner"
                fill
                priority
                objectFit="fill"
                objectPosition="center"
                sizes="300px"
              />
            </Box>

            <IconButton
              onClick={() => setHideBanner(true)}
              sx={{ svg: { path: { fill: '#fff' } } }}
            >
              <CloseIcon />
            </IconButton>
          </Stack>
        </Stack>
      </HomeViewContainer>
    </Box>
  )
}
